import supabase from '../lib/supabase';

/**
 * Fetches active AI agents from Supabase, filtered by team assignments
 *
 * @param {string[]|null} teamIds - Array of team IDs to filter agents by, or null for no team filter
 * @param {boolean} isAdmin - Whether the current user is an admin (admins can see all agents)
 * @returns {Promise<Array>} - Array of agent objects
 */
export const fetchActiveAgents = async (teamIds = null, isAdmin = false) => {
  try {
    console.log('Fetching active agents with params:', { teamIds, isAdmin });

    if (isAdmin) {
      // Admins get all active agents
      const { data, error } = await supabase
        .from('ai_agents_a1b2c3d4e5')
        .select('*')
        .eq('is_active', true)
        .order('name');

      if (error) throw error;

      console.log(`Fetched ${data?.length || 0} active agents`);
      return data || [];
    }

    // Non-admins: Only agents assigned to the provided teamIds
    if (!teamIds || teamIds.length === 0) {
      // No teams provided: Return empty array for non-admins
      console.log('No teamIds provided for non-admin; returning empty array');
      return [];
    }

    // Fetch assigned agent IDs for the teams
    const { data: allowedData, error: allowedError } = await supabase
      .from('team_allowed_agents_a1b2c3d4e5')
      .select('agent_id')
      .in('team_id', teamIds);

    if (allowedError) throw allowedError;

    const allowedAgentIds = [...new Set(
      allowedData?.map(row => row.agent_id).filter(id => id != null) || []
    )];

    if (allowedAgentIds.length === 0) {
      console.log('No agents assigned to provided teams; returning empty array');
      return [];
    }

    // Fetch full agent details for allowed IDs
    const { data, error } = await supabase
      .from('ai_agents_a1b2c3d4e5')
      .select('*')
      .eq('is_active', true)
      .in('id', allowedAgentIds)
      .order('name');

    if (error) throw error;

    console.log(`Fetched ${data?.length || 0} active agents`);
    return data || [];
  } catch (error) {
    console.error('Error fetching AI agents:', error);
    return [];
  }
};